export const FIFA_LOGO_URL =
  "https://digitalhub.fifa.com/transform/befe3a64-328b-453c-8b58-0faeb9103684/FIFA_Logo_White_Generic?io=transform:fill,height:25&quality=75";
